package com.cybersoftsolution.cybersoftsolutionweb.api

import com.cybersoftsolution.cybersoftsolutionweb.models.AuthRequest
import com.cybersoftsolution.cybersoftsolutionweb.models.AuthResponse
import com.cybersoftsolution.cybersoftsolutionweb.models.RestorePasswordParams
import com.cybersoftsolution.cybersoftsolutionweb.models.SignInParams
import com.cybersoftsolution.cybersoftsolutionweb.models.SignUpParams
import com.cybersoftsolution.cybersoftsolutionweb.models.SignUpResponse
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.AUTHENTICATE_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.RESTORE_PASSWORD_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.SIGN_IN_ROUTE
import com.cybersoftsolution.cybersoftsolutionweb.models.Values.SIGN_UP_ROUTE
import com.varabyte.kobweb.browser.api
import kotlinx.browser.window
import kotlinx.serialization.json.Json
import kotlinx.serialization.encodeToString


suspend fun authenticate(userId: String, authorizationToken:String): AuthResponse? {
    return try {
        val request = window.api.tryPost(
            apiPath = AUTHENTICATE_ROUTE,
            body = Json.encodeToString(
                AuthRequest(
                    userId = userId,
                    authorizationToken = authorizationToken
                )
            ).encodeToByteArray()
        )

        request?.let {
            Json.decodeFromString<AuthResponse?>(it.decodeToString() )
        }

    } catch (e: Exception) {
        console.error("logIn Error: ${e.message}")
        null
    }

}


suspend fun logIn(account: String, password: String): AuthResponse? {
    return try {
        val request = window.api.tryPost(
            apiPath = SIGN_IN_ROUTE,
            body = Json.encodeToString(
                SignInParams(
                    account,
                    password
                )
            ).encodeToByteArray()
        )

        request?.let {
            Json.decodeFromString<AuthResponse?>(it.decodeToString() )
        } ?: (
            AuthResponse(errorMessage = "Something went wrong. Please try again.")
        )



    } catch (e: Exception) {
        console.error("logIn Error: ${e.message}")
        AuthResponse(errorMessage = "Something went wrong. Please try again.")
    }

}

suspend fun signUp(
    signUpParams: SignUpParams
): SignUpResponse? {
    return try {
        val request = window.api.tryPost(
            apiPath = SIGN_UP_ROUTE,
            body = Json.encodeToString(
                signUpParams
            ).encodeToByteArray()
        )

        request?.let {
            Json.decodeFromString<SignUpResponse?>(it.decodeToString() )
        } ?: (
                SignUpResponse(errorMessage = "Something went wrong. Please try again.")
                )



    } catch (e: Exception) {
        console.error("signUp Error: ${e.message}")
        SignUpResponse(errorMessage = "Something went wrong. Please try again.")
    }

}

suspend fun restorePassword(
    restorePasswordParams: RestorePasswordParams
): SignUpResponse? {
    return try {
        val request = window.api.tryPost(
            apiPath = RESTORE_PASSWORD_ROUTE,
            body = Json.encodeToString(
                restorePasswordParams
            ).encodeToByteArray()
        )

        request?.let {
            Json.decodeFromString<SignUpResponse?>(it.decodeToString() )
        } ?: (
                SignUpResponse(errorMessage = "Something went wrong. Please try again.")
                )



    } catch (e: Exception) {
        console.error("restorePassword Error: ${e.message}")
        SignUpResponse(errorMessage = "Something went wrong. Please try again.")
    }

}



//suspend fun getUserByEmail(email: String): User? {
//    return try {
//        val result = window.api.tryPost(
//            apiPath = "get",
//            body = Json.encodeToString(User(email = email)).encodeToByteArray()
//        )
//        Json.decodeFromString<User>(result?.decodeToString()?: "" )
//    } catch (e: Exception) {
//        console.error("getUserByEmail Error: ${e.message}")
//        null
//    }

//}
